import TableSortOrder from "./TableSortOrder.vue";

export type { ModelSortDirection, Props } from "./TableSortOrder.vue";
export default TableSortOrder;
